import { Component, OnInit } from '@angular/core';
import { SessionVar, RespTranCode, APIUrl } from 'src/app/enums/emums';
import { ApidataService } from 'src/app/services/apidata.service';
import * as moment from 'moment';

@Component({
  selector: 'aditya-paymentsuccess',
  templateUrl: './paymentsuccess.component.html',
  styleUrls: ['./paymentsuccess.component.css']
})
export class PaymentsuccessComponent implements OnInit {
  Domain = '';
  data = {
    "TransactionID": "",
    "Date": "",
    "Mode": "",
    "Status": "",
    "Mobile": "",
    "Amount": "",
    "OperatorName": "",
    "OperatorId": "",
    "isBBPS": false
  }
  MobileRecharge: string = 'Mobile Recharge'
  RechargeSuccessful: string = 'Recharge Successful';
  constructor(private apiData: ApidataService) { }

  ngOnInit() {
    this.Domain = APIUrl.Domain;
    this.getData()
  }

  getData() {
    debugger
    var req = this.apiData.getSessionData(SessionVar.TransactionRequest);
    var resp = this.apiData.getSessionData(SessionVar.TransactionResponse);
    if (req) {
      const operator = req.oid;
      const odata = this.apiData.getOperatorData(operator);

      this.data = {
        Amount: req.amount,
        Date: moment(new Date()).format("DD MMM YYYY"),
        Mobile: req.accountNo,
        Mode: 'Wallet',
        OperatorId: operator,
        OperatorName: odata.name,
        Status: resp.statuscode == RespTranCode.Success ? 'Success' : 'Pending',
        TransactionID: resp.transactionID,
        isBBPS: odata.isBBPS
      }
      this.MobileRecharge = req.subject == undefined ? 'Mobile Recharge' : 'Upi Payment';
      this.RechargeSuccessful = req.subject == undefined ? this.RechargeSuccessful : 'Upi Payment Successful';
    }

    if (resp && resp.statuscode == RespTranCode.Success) {
      this.apiData.getBalance();
    }


  }

}
